/**
 * @generated SignedSource<<93d89d325fe3faa66de6b2018760f739>>
 * @relayHash 7f9ac6b36e201c546defa1b2eb549700
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7f9ac6b36e201c546defa1b2eb549700

import { ConcreteRequest } from 'relay-runtime';
export type NumberOfEmployeesRange = "C_00001_00010" | "C_00011_00050" | "C_00051_00100" | "C_00101_00250" | "C_00251_00500" | "C_00501_01000" | "C_01001_05000" | "C_05001_10000" | "C_10001_MAX" | "%future added value";
export type UpdateOrganizationInput = {
  description?: string | null;
  externalLinks?: ReadonlyArray<ExternalLinkInput> | null;
  founderNames?: ReadonlyArray<string> | null;
  id: string;
  industryCategoryIds?: ReadonlyArray<string> | null;
  location?: string | null;
  locationGooglePlaceId?: string | null;
  logoImage?: UploadedImageInput | null;
  logoImageUid?: string | null;
  name?: string | null;
  numberOfContractorsWorkingWith?: NumberOfContractorsWorkingWithRangeInput | null;
  numberOfEmployees?: NumberOfEmployeesRange | null;
  url?: any | null;
  yearFounded?: number | null;
};
export type ExternalLinkInput = {
  label?: string | null;
  url: any;
};
export type UploadedImageInput = {
  animated: boolean;
  checksum?: string | null;
  height: number;
  originalFormat: string;
  resourceType?: string | null;
  sizeBytes: number;
  uid: string;
  width: number;
};
export type NumberOfContractorsWorkingWithRangeInput = {
  max: number;
  min: number;
};
export type useCroppingCompanyProfileMutation$variables = {
  input: UpdateOrganizationInput;
};
export type useCroppingCompanyProfileMutation$data = {
  readonly updateProfile: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }> | null;
    readonly organization: {
      readonly logoImage: {
        readonly dominantHexColor: string | null;
        readonly id: string;
        readonly uid: string;
        readonly url: string;
      } | null;
    } | null;
  };
};
export type useCroppingCompanyProfileMutation = {
  response: useCroppingCompanyProfileMutation$data;
  variables: useCroppingCompanyProfileMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ContraImage",
  "kind": "LinkedField",
  "name": "logoImage",
  "plural": false,
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dominantHexColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "uid",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v5 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useCroppingCompanyProfileMutation",
    "selections": [
      {
        "alias": "updateProfile",
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrganizationPayload",
        "kind": "LinkedField",
        "name": "updateOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useCroppingCompanyProfileMutation",
    "selections": [
      {
        "alias": "updateProfile",
        "args": (v1/*: any*/),
        "concreteType": "UpdateOrganizationPayload",
        "kind": "LinkedField",
        "name": "updateOrganization",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "CollaboratorRoleCountInvalidError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "OrganizationNotFoundError",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ProductizedServiceCollaboratorNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "ReferBasicOpportunityUserNotFound",
                "abstractKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": (v5/*: any*/),
                "type": "SubmitJoinOrganizationRequestError",
                "abstractKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Organization",
            "kind": "LinkedField",
            "name": "organization",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "7f9ac6b36e201c546defa1b2eb549700",
    "metadata": {},
    "name": "useCroppingCompanyProfileMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "aa56a519802753611cb22e2fd950522c";

export default node;
